import React, { useEffect, useRef, useState } from 'react';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import {
    APP_NOTIFICATION_HIDDEN_EVENT,
    APP_NOTIFICATION_STATE_EVENT,
    APP_NOTIFICATION_STATE_GLOBAL,
    SHOW_APP_NOTIFICATION_BANNER_EVENT,
    HEADERS,
} from '../consts';
import css from '../style.css';

function NotificationIndicator() {
    // The Angular state event can fire before this component mounts.
    const [show, setShow] = useState(() => !!window[APP_NOTIFICATION_STATE_GLOBAL]);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        const onState = event => setShow(!!event.detail?.show);
        const onHidden = () => {
            setPopoverVisible(true);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setPopoverVisible(false), 3000);
        };
        window.addEventListener(APP_NOTIFICATION_STATE_EVENT, onState);
        window.addEventListener(APP_NOTIFICATION_HIDDEN_EVENT, onHidden);
        return () => {
            window.removeEventListener(APP_NOTIFICATION_STATE_EVENT, onState);
            window.removeEventListener(APP_NOTIFICATION_HIDDEN_EVENT, onHidden);
            clearTimeout(timerRef.current);
        };
    }, []);

    if (!show) {
        return null;
    }

    return (
        <div className={css.menuContainer}>
            <button
                type="button"
                aria-label="app notification"
                className={css.iconButton}
                onClick={() => window.dispatchEvent(new CustomEvent(SHOW_APP_NOTIFICATION_BANNER_EVENT))}
            >
                <Icon name="alert-circle" size={IconSizes.SMALL} variant={IconVariants.WHITE} />
            </button>
            {popoverVisible && (
                <div className={css.menuPanel}>
                    <Translate id={`${HEADERS}.NOTIFICATION_TOOLTIP`} />
                </div>
            )}
        </div>
    );
}

export default NotificationIndicator;
